(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bio-cart-upgrade]');
    if (!button) return;
    var items = button.closest('cart-drawer-items, cart-items');
    if (!items) return;
    button.disabled = true;
    if (button.dataset.plan) {
      changeLine(items, button.dataset.line, button.dataset.quantity, button.dataset.plan);
    } else {
      items.updateQuantity(button.dataset.line, Number(button.dataset.quantity), event, null, button.dataset.variantId);
    }
  });

  // A subscription upgrade changes the quantity and the plan together, which Dawn's
  // quantity update can't do, then re-renders the cart from the response.
  function changeLine(items, line, quantity, plan) {
    var sections = items.getSectionsToRender();
    if (items.enableLoading) items.enableLoading(line);
    fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: Number(line),
        quantity: Number(quantity),
        selling_plan: Number(plan),
        sections: sections.map(function (section) {
          return section.section;
        }),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status || !state.sections) throw new Error(state.description || 'change failed');
        sections.forEach(function (section) {
          var holder = document.getElementById(section.id);
          if (!holder) return;
          var target = holder.querySelector(section.selector) || holder;
          target.innerHTML = items.getSectionInnerHTML(state.sections[section.section], section.selector);
        });
      })
      .catch(function () {
        window.location.reload();
      });
  }

  // Each plan is priced for a set number of bottles ("Buy 2 Get 1 Free" is 3), so a new
  // quantity moves the line to the biggest plan it still fills. data-plans is "1:id,3:id".
  function planForQuantity(input, quantity) {
    var best = null;
    var smallest = null;
    input.dataset.plans.split(',').forEach(function (option) {
      var parts = option.split(':');
      var plan = { qty: Number(parts[0]), id: parts[1] };
      if (!smallest || plan.qty < smallest.qty) smallest = plan;
      if (plan.qty <= quantity && (!best || plan.qty > best.qty)) best = plan;
    });
    return (best || smallest).id;
  }

  // Shopify puts its subscription notice under the express checkout buttons. It is moved
  // below the cart FAQ; if it can't be reached, it stays where Shopify put it.
  function findTerms(root) {
    var found = null;
    root.querySelectorAll('*').forEach(function (element) {
      if (found) return;
      if (element.shadowRoot) found = findTerms(element.shadowRoot);
      if (found || !/recurring purchase/i.test(element.textContent)) return;
      var inner = Array.prototype.some.call(element.children, function (child) {
        return /recurring purchase/i.test(child.textContent);
      });
      if (!inner && !element.shadowRoot) found = element;
    });
    return found;
  }

  function moveTerms() {
    document.querySelectorAll('[data-bio-terms][hidden]').forEach(function (target) {
      var scope = target.closest('cart-drawer, .bio-cart--page') || document;
      var express = scope.querySelector('.bio-cart__express');
      var terms = express && findTerms(express);
      if (!terms) return;
      var copy = terms.cloneNode(true);
      copy.style.removeProperty('display');
      target.replaceChildren(copy);
      terms.style.setProperty('display', 'none', 'important');
      target.hidden = false;
    });
  }

  setInterval(moveTerms, 400);

  // The cart page reuses the drawer contents in one section, so it re-renders that section
  // instead of Dawn's separate cart items and cart footer sections.
  var CartItems = customElements.get('cart-items');
  if (CartItems) {
    var dawnSections = CartItems.prototype.getSectionsToRender;
    var dawnCartUpdate = CartItems.prototype.onCartUpdate;
    var dawnUpdateQuantity = CartItems.prototype.updateQuantity;

    CartItems.prototype.updateQuantity = function (line, quantity, event, name, variantId) {
      var input = this.querySelector('#Quantity-' + line) || this.querySelector('#Drawer-quantity-' + line);
      if (quantity > 0 && input && input.dataset.plans) {
        var plan = planForQuantity(input, quantity);
        if (plan !== input.dataset.plan) return changeLine(this, line, quantity, plan);
      }
      return dawnUpdateQuantity.call(this, line, quantity, event, name, variantId);
    };

    CartItems.prototype.getSectionsToRender = function () {
      if (!this.hasAttribute('data-bio-cart-page')) return dawnSections.call(this);
      return [
        { id: 'main-cart-items', section: this.dataset.id, selector: '.js-contents' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      ];
    };

    CartItems.prototype.onCartUpdate = function () {
      if (!this.hasAttribute('data-bio-cart-page')) return dawnCartUpdate.call(this);
      var page = this;
      return fetch(routes.cart_url + '?section_id=' + page.dataset.id)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var source = new DOMParser().parseFromString(text, 'text/html').querySelector('.js-contents');
          if (source) page.querySelector('.js-contents').innerHTML = source.innerHTML;
        })
        .catch(function (error) {
          console.error(error);
        });
    };
  }

  function pad(number) {
    return String(number).padStart(2, '0');
  }

  function tick() {
    document.querySelectorAll('cart-drawer.active [data-bio-timer], .bio-cart--page [data-bio-timer]').forEach(function (timer) {
      var loop = Number(timer.dataset.hours) * 3600000;
      var seconds = Math.ceil((loop - (Date.now() % loop)) / 1000);
      timer.querySelector('[data-bio-timer-h]').textContent = pad(Math.floor(seconds / 3600));
      timer.querySelector('[data-bio-timer-m]').textContent = pad(Math.floor((seconds % 3600) / 60));
      timer.querySelector('[data-bio-timer-s]').textContent = pad(seconds % 60);
    });
  }

  setInterval(tick, 250);
})();
